import React from 'react'
import { Path } from 'react-native-svg'
import styled from 'styled-components/native'

import { AccessibleSvg } from 'ui/svg/AccessibleSvg'

import { AccessibleIcon } from './types'

const LocationBuildingFilledSvg: React.FunctionComponent<AccessibleIcon> = ({
  size,
  color,
  accessibilityLabel,
  testID,
}) => (
  <AccessibleSvg
    width={size}
    height={size}
    viewBox="0 0 48 48"
    fill="none"
    accessibilityLabel={accessibilityLabel}
    testID={testID}>
    <Path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M39.5573 3.42786H23.8716C22.5259 3.42786 21.4287 4.525 21.4287 5.87071V21.0593H28.0973C31.7144 21.0593 34.6544 23.9993 34.6544 27.6164V43.1821C34.6544 43.6707 34.5516 44.125 34.4059 44.5621H39.5573C40.903 44.5621 42.0001 43.465 42.0001 42.1193V5.87071C42.0001 4.525 40.903 3.42786 39.5573 3.42786ZM27.0344 17.7593C27.0344 18.2736 26.6144 18.6936 26.1001 18.6936C25.5859 18.6936 25.1659 18.2736 25.1659 17.7593V15.8907C25.1659 15.3764 25.5859 14.9564 26.1001 14.9564C26.6144 14.9564 27.0344 15.3764 27.0344 15.8907V17.7593ZM27.0344 11.1336C27.0344 11.6479 26.6144 12.0679 26.1001 12.0679C25.5859 12.0679 25.1659 11.6479 25.1659 11.1336V9.265C25.1659 8.75071 25.5859 8.33071 26.1001 8.33071C26.6144 8.33071 27.0344 8.75071 27.0344 9.265V11.1336ZM32.6487 17.7593C32.6487 18.2736 32.2287 18.6936 31.7144 18.6936C31.2001 18.6936 30.7801 18.2736 30.7801 17.7593V15.8907C30.7801 15.3764 31.2001 14.9564 31.7144 14.9564C32.2287 14.9564 32.6487 15.3764 32.6487 15.8907V17.7593ZM32.6487 11.1336C32.6487 11.6479 32.2287 12.0679 31.7144 12.0679C31.2001 12.0679 30.7801 11.6479 30.7801 11.1336V9.265C30.7801 8.75071 31.2001 8.33071 31.7144 8.33071C32.2287 8.33071 32.6487 8.75071 32.6487 9.265V11.1336ZM38.263 32.7936C38.263 33.3079 37.843 33.7279 37.3287 33.7279C36.8144 33.7279 36.3944 33.3079 36.3944 32.7936V30.925C36.3944 30.4107 36.8144 29.9907 37.3287 29.9907C37.843 29.9907 38.263 30.4107 38.263 30.925V32.7936ZM38.263 25.2336C38.263 25.7479 37.843 26.1679 37.3287 26.1679C36.8144 26.1679 36.3944 25.7479 36.3944 25.2336V23.365C36.3944 22.8507 36.8144 22.4307 37.3287 22.4307C37.843 22.4307 38.263 22.8507 38.263 23.365V25.2336ZM38.263 17.7507C38.263 18.265 37.843 18.685 37.3287 18.685C36.8144 18.685 36.3944 18.265 36.3944 17.7507V15.8821C36.3944 15.3679 36.8144 14.9479 37.3287 14.9479C37.843 14.9479 38.263 15.3679 38.263 15.8821V17.7507ZM38.263 11.125C38.263 11.6393 37.843 12.0593 37.3287 12.0593C36.8144 12.0593 36.3944 11.6393 36.3944 11.125V9.25643C36.3944 8.74214 36.8144 8.32214 37.3287 8.32214C37.843 8.32214 38.263 8.74214 38.263 9.25643V11.125Z"
      fill={color}
    />
    <Path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M28.0971 23.9993H9.61714C7.62 23.9993 6 25.6193 6 27.6164V43.1821C6 43.945 6.61714 44.5621 7.38 44.5621H15.2571V35.8964C15.2571 35.005 15.9771 34.2764 16.8771 34.2764H20.8457C21.7371 34.2764 22.4657 34.9964 22.4657 35.8964V44.5621H30.3429C31.1057 44.5621 31.7229 43.945 31.7229 43.1821V27.6164C31.7229 25.6193 30.1029 23.9993 28.1057 23.9993H28.0971Z"
      fill={color}
    />
  </AccessibleSvg>
)

export const LocationBuildingFilled = styled(LocationBuildingFilledSvg).attrs(
  ({ color, size, theme }) => ({
    color: color ?? theme.colors.black,
    size: size ?? theme.icons.sizes.standard,
  })
)``
